@switch (variant) {
  @case ('fontawesome') {
    <fa-icon [icon]="iconSpinner" [animation]="'spin'" [size]="spinnerSize()" />
  }
  @case ('rocket') {
    <fmnts-rocket [size]="size" [color]="color" [animateThrusts]="true" />
  }
}
